import { t } from '@lingui/core/macro';
import { Box, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function UnknownField() {
    const title = t({
        message: 'Property unavailable',
        comment: 'Insights: Widget uses an unavailable metadata property - title',
    });
    const description = t({
        message: 'This widget uses a metadata property that no longer exists in this workspace.',
        comment: 'Insights: Widget uses an unavailable metadata property - description',
    });
    return (<Box flexDirection="column" justifyContent="center" width="100%" height="100%">
      <EmptyState withAvatar title={title} description={description} icon={<Falcon icon="circle-question"/>}/>
    </Box>);
}
